import * as MD from '@material-ui/core';
import { red } from '@material-ui/core/colors';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import LockIcon from '@material-ui/icons/Lock';
import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import { IApplicationState, IConnectedReduxProps } from '../../../Store';
import { I18N } from '../../../Store/I18n/Types';
import { IUserState } from '../../../Store/User/Types';
import { getACLUsers } from '../../../Store/UserManagement/Actions';
import {
	IUserManagementState,
	IUserSearchParams,
	IUserSearchParamsSorting,
	UserACL,
} from '../../../Store/UserManagement/Types';
import { getTheme } from '../../../Themes';
import { ButtonDensed } from '../../../Themes/StyledElements';
import {
	isNullOrUndefinedOrEmptyString,
	isNullOrUndefinedOrZero,
} from '../../../Utils/Various';
import { ChannelsPopup } from './ChannelsPopup';

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<{}>;
	user: IUserState;
	userManagement: IUserManagementState;
}

interface IState {
	openedUser: number;
	page: number;
	resultsPerPage: number;
	params: IUserSearchParamsSorting;
	anchorMenuChannel: null | HTMLElement;
	currentID: number;
	showChannelsPopup: boolean;
}

interface IPropsFromDispatch {
	getACLUsers: typeof getACLUsers;
}

const theme = getTheme();

const styles = MD.createStyles({
	row: {
		'& > *': {
			borderBottom: 'unset',
		},
	},
	table: {
		minWidth: 750,
	},
	margin: {
		margin: theme.spacing(1),
	},
	noResult: {
		textAlign: 'center',
		fontSize: 'large',
	},
	visuallyHidden: {
		border: 0,
		clip: 'rect(0 0 0 0)',
		height: 1,
		margin: -1,
		overflow: 'hidden',
		padding: 0,
		position: 'absolute',
		top: 20,
		width: 1,
	},
	smallIcon: {
		padding: '3px',
	},
	cell5: {
		width: '5%',
	},
	cell15: {
		width: '15%',
	},
	cell20: {
		width: '20%',
	},
});

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

export class UserManagementContentGroupsListComponent extends React.Component<
	AllProps,
	IState
> {
	private switchTimer = -1;

	public constructor(props: AllProps) {
		super(props);
		this.state = {
			currentID: 0,
			openedUser: -1,
			page: 0,
			resultsPerPage: 50,
			params: {
				sortingBy: 'ID',
				sortingOrder: 'asc',
			},
			anchorMenuChannel: null,
			showChannelsPopup: false,
		};
	}

	public componentDidMount() {
		if (this.props.user.groupID === 2) {
			this.props.getACLUsers(
				this.props.user.token,
				{
					isGroup: true,
					researchText: '',
					showInactive: false,
					usersParentID: 0,
				},
				this.state.params,
				this.state.resultsPerPage,
				this.state.page
			);
		} else {
			document.location.href = window.location.pathname.replace(
				'groups',
				'users'
			);
		}
	}

	public render(): React.ReactNode {
		return this.props.userManagement.ACLUsersLoading
			? this.renderLoading()
			: this.renderLoaded();
	}

	private renderLoading(): React.ReactNode {
		return (
			<div style={{ paddingTop: 30 }}>
				{this.props.i18n._('Loading')}...
			</div>
		);
	}

	private renderLoaded(): React.ReactNodeArray {
		return [
			<div key="csv-button">{this.displayCSVButton()}</div>,
			<div key="table-pagination">{this.displayTablePagination()}</div>,
			<div key="table">{this.displayTable()}</div>,
			<ChannelsPopup
				key="channels-popup"
				open={Boolean(this.state.showChannelsPopup)}
				onClose={() => {
					this.setState({ showChannelsPopup: false });
				}}
				targetId={this.state.currentID}
				token={this.props.user.token}
				isGroup={true}
			/>
		];
	}

	private redirection(): React.ReactNode {
		return <Redirect to="/" />;
	}

	private displayCSVButton(): React.ReactNode {
		return (
			<MD.Button
				onClick={() => {
					let arr = this.props.userManagement.usersACLData;
					let newarr: string[][] = [];
					newarr.push([
						'id',
						'firstname',
						'name',
						'username',
						'email',
						'date creation',
						'date debut',
						'date fin',
						'is active',
						'phone',
						'group name',
					]);
					arr.forEach((element) => {
						let newarrrow = [
							isNullOrUndefinedOrZero(element.id)
								? 'No data'
								: element.id.toString(10),
							isNullOrUndefinedOrEmptyString(element.firstname)
								? 'No data'
								: element.firstname.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.name)
								? 'No data'
								: element.name.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.username)
								? 'No data'
								: element.username.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.email)
								? 'No data'
								: element.email.replace('#', ''),
							isNullOrUndefinedOrEmptyString(
								element.date_creation
							)
								? 'No data'
								: element.date_creation.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.date_debut)
								? 'No data'
								: element.date_debut.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.date_expire)
								? 'No data'
								: element.date_expire.replace('#', ''),
							element.isactive ? 'active' : 'inactive',
							isNullOrUndefinedOrEmptyString(element.phone)
								? 'No data'
								: element.phone.replace('#', ''),
							isNullOrUndefinedOrEmptyString(element.parent.name)
								? 'No data'
								: element.parent.name.replace('#', ''),
						];
						newarr.push(newarrrow);
					});

					let csvContent =
						'data:text/csv;charset=utf-8,' +
						newarr.map((e) => e.join(';')).join('\n');

					let encodedUri = encodeURI(csvContent);
					window.open(encodedUri);
				}}
			>
				extract CSV
			</MD.Button>
		);
	}

	private displayTablePagination(): React.ReactNode {
		return (
			<MD.TablePagination
				component="div"
				count={this.props.userManagement.usersCount}
				rowsPerPage={this.state.resultsPerPage}
				page={this.state.page}
				rowsPerPageOptions={[10, 20, 50, 100, 300]}
				onPageChange={(
					event: React.MouseEvent<HTMLButtonElement> | null,
					page: number
				) => {
					this.setState({
						...this.state,
						page,
					});
					this.refresh();
				}}
				onRowsPerPageChange={(
					event: React.ChangeEvent<
						HTMLTextAreaElement | HTMLInputElement
					>
				) => {
					const rows = parseInt(event.target.value, 10);

					if (isNaN(rows)) {
						return;
					}
					this.setState({
						...this.state,
						page: 0,
						resultsPerPage: rows,
					});
					this.refresh();
				}}
			/>
		);
	}

	private displayTable(): React.ReactNode {
		return (
			<MD.TableContainer component={MD.Paper}>
				<MD.Table aria-label="collapsible table" size="small">
					{this.displayTableHead()}
					{this.displayTableBody()}
				</MD.Table>
			</MD.TableContainer>
		);
	}

	private displayTableHead(): React.ReactNode {
		const classes = this.props.classes;
		return (
			<MD.TableHead>
				<MD.TableRow>
					<MD.TableCell className={classes.cell5} />
					<MD.TableCell className={classes.cell5}>
						<MD.TableSortLabel
							active={this.state.params.sortingBy === 'ID'}
							onClick={() => {
								if (this.state.params.sortingBy === 'ID') {
									this.state.params.sortingOrder === 'asc'
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'desc',
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'asc',
												},
										  });
								} else {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											sortingBy: 'ID',
											sortingOrder: 'asc',
										},
									});
								}
								this.refresh();
							}}
							direction={
								this.state.params.sortingBy === 'ID'
									? this.state.params.sortingOrder
									: 'asc'
							}
						>
							ID
						</MD.TableSortLabel>
					</MD.TableCell>
					<MD.TableCell className={classes.cell20} align="left">
						<MD.TableSortLabel
							active={this.state.params.sortingBy === 'NAME'}
							onClick={() => {
								if (this.state.params.sortingBy === 'NAME') {
									this.state.params.sortingOrder === 'asc'
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'desc',
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'asc',
												},
										  });
								} else {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											sortingBy: 'NAME',
											sortingOrder: 'asc',
										},
									});
								}
								this.refresh();
							}}
							direction={
								this.state.params.sortingBy === 'NAME'
									? this.state.params.sortingOrder
									: 'asc'
							}
						>
							{this.props.i18n._('Name')}
						</MD.TableSortLabel>
					</MD.TableCell>
					<MD.TableCell className={classes.cell20} align="left">
						<MD.TableSortLabel
							active={this.state.params.sortingBy === 'FIRSTNAME'}
							onClick={() => {
								if (
									this.state.params.sortingBy === 'FIRSTNAME'
								) {
									this.state.params.sortingOrder === 'asc'
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'desc',
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'asc',
												},
										  });
								} else {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											sortingBy: 'FIRSTNAME',
											sortingOrder: 'asc',
										},
									});
								}
								this.refresh();
							}}
							direction={
								this.state.params.sortingBy === 'FIRSTNAME'
									? this.state.params.sortingOrder
									: 'asc'
							}
						>
							{this.props.i18n._('First name')}
						</MD.TableSortLabel>
					</MD.TableCell>
					<MD.TableCell className={classes.cell20} align="left">
						<MD.TableSortLabel
							active={this.state.params.sortingBy === 'USERNAME'}
							onClick={() => {
								if (
									this.state.params.sortingBy === 'USERNAME'
								) {
									this.state.params.sortingOrder === 'asc'
										? this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'desc',
												},
										  })
										: this.setState({
												...this.state,
												params: {
													...this.state.params,
													sortingOrder: 'asc',
												},
										  });
								} else {
									this.setState({
										...this.state,
										params: {
											...this.state.params,
											sortingBy: 'USERNAME',
											sortingOrder: 'asc',
										},
									});
								}
								this.refresh();
							}}
							direction={
								this.state.params.sortingBy === 'USERNAME'
									? this.state.params.sortingOrder
									: 'asc'
							}
						>
							{this.props.i18n._('Username')}
						</MD.TableSortLabel>
					</MD.TableCell>
					<MD.TableCell className={classes.cell15} align="left">
						{this.props.i18n._('Users in group')}
					</MD.TableCell>
					<MD.TableCell className={classes.cell15} align="left">
						{this.props.i18n._('Display Rights')}
					</MD.TableCell>
					<MD.TableCell className={classes.cell15} align="left">
						{this.props.i18n._('Channels')}
					</MD.TableCell>
				</MD.TableRow>
			</MD.TableHead>
		);
	}

	private generateRow(user: UserACL, i: number): React.ReactNode {
		const classes = this.props.classes;

		return (
			<React.Fragment key={i}>
				<MD.TableRow className={classes.row}>
					<MD.TableCell>
						<MD.IconButton
							aria-label="expand row"
							size="small"
							onClick={() => {
								if (this.state.openedUser === user.id) {
									this.setState({ openedUser: -1 });
								} else {
									this.setState({ openedUser: user.id });
								}
							}}
						>
							{this.state.openedUser === user.id ? (
								<KeyboardArrowUpIcon />
							) : (
								<KeyboardArrowDownIcon />
							)}
						</MD.IconButton>
					</MD.TableCell>
					<MD.TableCell component="th" scope="row">
						{user.id}
					</MD.TableCell>
					<MD.TableCell align="left">{user.name}</MD.TableCell>
					<MD.TableCell align="left">{user.firstname}</MD.TableCell>
					<MD.TableCell align="left">{user.username}</MD.TableCell>
					<MD.TableCell align="left">
						<ButtonDensed
							style={{ marginTop: '0px' }}
							color="secondary"
							variant="contained"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/users/users/${user.id}`
								);
							}}
						>
							{this.props.i18n._('retrieve all users')}
						</ButtonDensed>
					</MD.TableCell>
					<MD.TableCell align="left">
						<IconButton
							className={classes.smallIcon}
							color="primary"
							aria-label="rights picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/users/rights/${user.id}`
								);
							}}
						>
							<LockIcon />
						</IconButton>
						<IconButton
							className={classes.smallIcon}
							color="primary"
							aria-label="edit picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/users/modify/${user.id}`
								);
							}}
						>
							<EditIcon />
						</IconButton>
						<IconButton
							className={classes.smallIcon}
							color="primary"
							aria-label="edit picture"
							component="span"
							onClick={(
								event: React.MouseEvent<
									HTMLButtonElement,
									MouseEvent
								>
							) => {
								this.props.router.history.push(
									`/users/property/${user.id}`
								);
							}}
						>
							<DeleteIcon style={{ color: red[500] }} />
						</IconButton>
					</MD.TableCell>
					<MD.TableCell align="left">
						<MD.Button
							aria-controls="menu-channel"
							aria-haspopup="true"
							onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
								this.setState({ currentID: user.id });
								this.openMenuChannel(event);
							}}
							style={{ marginRight: '8px' }}
						>
							Channels
						</MD.Button>
						<MD.Button
							color="primary"
							onClick={() => {
								this.setState({
									currentID: user.id,
									showChannelsPopup: true
								});
							}}
						>
							Quick Edit
						</MD.Button>
						<MD.Menu
							id="menu-channel"
							anchorEl={this.state.anchorMenuChannel}
							keepMounted
							open={Boolean(this.state.anchorMenuChannel)}
							onClose={(event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
								this.closeMenuChannel();
							}}
						>
							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mediaarchiver-group/${this.state.currentID}`
									);
								}}
							>
								Mediaarchiver - global
							</MD.MenuItem>
							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mediaarchiver-tpp-group/${this.state.currentID}`
									);
								}}
							>
								Mediaarchiver - TPP
							</MD.MenuItem>
							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mediaarchiver-stt-group/${this.state.currentID}`
									);
								}}
							>
								MediaArchiver - STT
							</MD.MenuItem>
							<MD.MenuItem
								onClick={() => {
									this.props.router.history.push(
										`/apps/mytrack-group/${this.state.currentID}`
									);
								}}
							>
								MyTrack - Global
							</MD.MenuItem>
						</MD.Menu>
					</MD.TableCell>
				</MD.TableRow>
				<MD.TableRow>
					<MD.TableCell
						style={{ paddingBottom: 0, paddingTop: 0 }}
						colSpan={8}
					>
						<MD.Collapse
							in={this.state.openedUser === user.id}
							timeout="auto"
							unmountOnExit
						>
							<MD.Box margin={1}>
								<MD.Typography
									variant="h6"
									gutterBottom
									component="div"
								>
									{this.props.i18n._('Other informations')}
								</MD.Typography>
								<MD.Table size="small" aria-label="subtable">
									<MD.TableHead>
										<MD.TableRow>
											<MD.TableCell>
												{this.props.i18n._('Active')}
											</MD.TableCell>
											<MD.TableCell>
												{this.props.i18n._(
													'Creation date'
												)}
											</MD.TableCell>
											<MD.TableCell align="right">
												{this.props.i18n._(
													'Start date'
												)}
											</MD.TableCell>
											<MD.TableCell align="right">
												{this.props.i18n._('End date')}
											</MD.TableCell>
										</MD.TableRow>
									</MD.TableHead>
									<MD.TableBody>
										<MD.TableRow>
											<MD.TableCell
												component="th"
												scope="row"
											>
												{user.isactive
													? this.props.i18n._(
															'Active'
													  )
													: this.props.i18n._(
															'Inactive'
													  )}
											</MD.TableCell>
											<MD.TableCell>
												{user.date_creation}
											</MD.TableCell>
											<MD.TableCell align="right">
												{user.date_debut}
											</MD.TableCell>
											<MD.TableCell align="right">
												{user.date_expire === ''
													? user.date_expire
													: this.props.i18n._(
															'No end date'
													  )}
											</MD.TableCell>
										</MD.TableRow>
									</MD.TableBody>
								</MD.Table>
							</MD.Box>
						</MD.Collapse>
					</MD.TableCell>
				</MD.TableRow>
			</React.Fragment>
		);
	}

	private closeMenuChannel() {
		this.setState({ anchorMenuChannel: null });
	}

	private openMenuChannel(event: React.MouseEvent<HTMLButtonElement>) {
		this.setState({ anchorMenuChannel: event.currentTarget });
	}

	private refresh() {
		if (this.switchTimer !== -1) {
			window.clearTimeout(this.switchTimer);
		}
		this.switchTimer = window.setTimeout(() => {
			this.props.getACLUsers(
				this.props.user.token,
				null,
				this.state.params,
				this.state.resultsPerPage,
				this.state.page
			);
			this.switchTimer = -1;
		}, 300);
	}

	private displayTableBody(): React.ReactNode | string {
		const classes = this.props.classes;

		if (this.props.userManagement.usersCount !== 0) {
			return (
				<MD.TableBody>
					{this.props.userManagement.usersACLData.map((u) =>
						this.generateRow(u, u.id)
					)}
				</MD.TableBody>
			);
		} else {
			return (
				<MD.TableBody>
					<MD.TableRow>
						<MD.TableCell colSpan={8} className={classes.noResult}>
							No result
						</MD.TableCell>
					</MD.TableRow>
				</MD.TableBody>
			);
		}
	}
}

const mapStateToProps = (
	{ i18n, user, userManagement }: IApplicationState,
	ownProps: RouteComponentProps<{}>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	userManagement,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLUsers: (
		token: string,
		params: IUserSearchParams | null,
		paramsSorting: IUserSearchParamsSorting | null,
		resultsPerPage?: number,
		page?: number
	) =>
		dispatch(
			getACLUsers(token, params, paramsSorting, resultsPerPage, page)
		),
});

export const UserManagementContentGroupsList = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(UserManagementContentGroupsListComponent));
